import { Template, Component, Attribute } from '@scoutgg/ftw/source/lib'
import { Match, Lineup } from '../../models'
import template from './results.jade'
import sources from '../../../helpers/sources'
import '../status'
import '../match-times'
import '../event-selector'
import '../event-submitter'
import '../lineups'
import '../event'
import '../quick-sets'
import shortcuts from '../../services/shortcuts'
import getState from '../../services/event-state'
import notify from '@scoutgg/ftw/source/services/notification'
import emitter from '@scoutgg/ftw/source/services/emitter'
import { prompt } from '@scoutgg/ftw/source/services/modal'
import { editableMatchStats } from '../../services/match-editor'
@Component('sporty')
@Template(template)
@Attribute('match', Match)
@Attribute('edit-mode', Boolean)


export default class Results extends HTMLElement {

  select(team) {
    getState(this.match).assignTeam(team)
  }
  changeFilterBOP({ filterBop }) {
    this.filterBop = filterBop
    this.render()
  }
  addExtraPlayer() {
    this.extraPlayerMenu = true
    this.render()
  }
  attached() {
    this.filterBop = false
    this.editMode = true
    this.fixMenu = false
    this.extraPlayerMenu = false
    this.showSums = false
    this.mapNames = [
      'de_dust2',
      'de_inferno',
      'de_nuke',
      'de_overpass',
      'de_vertigo',
      'de_train',
      'de_mirage',
    ]
    this.newMaps = {}
    this.overrides = this.match?.overrides || {}
    this.enabledStats = {}
    if(this.match.sport === 'hockey') this.editHockey = true
    this.matchChange()
    this.listeners = []
    this.listeners.push(shortcuts(['h', 'l'], (key, n) => {
      var team = key === 'h' ? this.match.homeTeam : this.match.awayTeam
      var lineup = this.lineups
        .find(l => l.player.teamId === team._id && l.player.shirt === +n)

      if(lineup) {
        getState(this.match).assignPlayer(lineup)
      } else {
        getState(this.match).assignTeam(team)
        if(n) console.error(`Unable to find player #${n} for team: ${team.name}`)
        return
      }
      this.render()
    }))
    var reset = this.reset.bind(this)
    this.listeners.push(shortcuts([' '], reset))
    this.on('click', '[data-clear]', reset)
  }

  reset() {
    getState(this.match).reset()
  }

  changeMatchStatStatus(stat) {
    if(!this.enabledStats[stat]) {
      this.enabledStats[stat] = true
    } else {
      this.enabledStats[stat] = !this.enabledStats[stat]
    }
    this.render()
  }

  editStats(team) {
    team.editStats = !team.editStats
    if(this.match.sport === 'hockey') team.showStats = !team.showStats
    this.state.reload(true)
    this.render()
  }

  showStats(team) {
    team.editStats = this.editHockey = false
    team.showStats = !team.showStats
    this.render()
  }

  uid(match) {
    const source = (match.matchSources || []).find(ms => ms.uid)
    return source && source.uid
  }

  matchChange() {
    this.update(this.match.load())
    getState(this.match).listen(this, true)
  }

  detached() {
    for(var unlisten of this.listeners) unlisten()
  }

  canScrapeLineups(source) {
    const provider = source.source || source.seasonSource?.source
    return sources[provider]?.lineups
  }

  canScrapeStats(source) {
    const provider = source.source || source.seasonSource?.source
    return sources[provider]?.stats
  }

  async clearEvents(source, version, type) {
    if(!this.isEsports) return
    if(this.match.stopFeeds || this.match.stopCompute) return
    const question = `
      DANGER: This action will delete the following from this match and its matchSource:\n
      ALL events -
      lastReceivedEvent -
      mapStartTimes -
      tAndCt -
      locations -
    `
    const confirmation = await prompt(question, {
      type: 'custom',
      level: 'danger',
      submitBtnName: 'Do it',
      cancelBtnName: 'Abort',
    })
    if(confirmation) {
      source.post('clear-events')
        .then(() => {
          notify('Events cleared', { level: 'success', timeout: 5000 })
          this.state.reload(true)
          if(version === 2) {
            if(type === 'historical') {
              this.scrapeLineups(source, { version: 2, historical: source.uid })
            } else {
              this.scrapeLineups(source, { forceRescrape: source.uid, version: 2 })
            }
          } else {
            this.scrapeLineups(source, { forceRescrape: source.uid, version: 1 })
          }
        })
        .catch((err) => {
          notify(err.message, { level: 'danger', timeout: 10000 })
        })
        .then(() => this.render())
    }
  }
  async scrapeLineups(source, opts) {

    if(opts && opts.clearEvents) {
      const question = `
      DANGER: This action will delete all manually edited and added events:\n
    `
      const confirmation = await prompt(question, {
        type: 'custom',
        level: 'danger',
        submitBtnName: 'Do it',
        cancelBtnName: 'Abort',
      })
    }
    source.post('scrape', opts)
      .then(() => {
        notify('Lineups gathered', { level: 'success', timeout: 5000 })
        return this.match.save()
      })
      .then(() => getState(this.match).reload(true))
      .catch((err) => notify(err.message, { level: 'danger', timeout: 10000 }))
  }

  sendFeeds() {
    if(this.match.$isSubmitting) return
    this.match.post('send-feeds')
      .then(() => { notify('Events sent', { level: 'success', timeout: 5000 }) })
      .catch((err) => {
        notify(err.message, { level: 'danger', timeout: 10000 })
      })
      .then(() => this.render())
    this.render()
  }
  compute() {
    this.match.post('compute-only')
      .then(() => {
        notify('Recomputed', { level: 'success', timeout: 3000 })
        this.state.reload(true)
      })
  }
  saveStats(team) {
    var lineups = this.match.lineups.map(lineup => {
      return {
        _id: lineup._id,
        batch: lineup.batch,
        match: lineup.matchId,
        player: lineup.playerId,
        team: lineup.teamId,
        stats: lineup.stats,
        status: lineup.status,
        duration: lineup.duration,
        lane: lineup.lane,
      }
    })
    this.match.post('edit-stats', { lineups, context: 'edit' }).then(() => {
      notify('Stats saved', { level: 'success', timeout: 3000 })
      this.state.reload(true)
      team.editStats = team.showStats = false
      emitter.emit('match-updated')
    })
  }

  setMatchStat(value, stat) {
    this.overrides[stat] = value
  }

  setNewMapName(number, value) {
    if(!this.newMaps[number]) this.newMaps[number] = {}
    this.newMaps[number].name = value
  }

  setNewMapNumber(number, value) {
    if(!this.newMaps[number]) this.newMaps[number] = {}
    this.newMaps[number].number = parseInt(value)
  }
  clearOverride() {
    this.overrides = {}
    this.match.post('update-match-details', { overrides: this.overrides } )
      .then(() => {
        notify('Set new value', { level: 'success', timeout: 3000 })
        this.state.reload(true)
        emitter.emit('match-updated')
    })
  }

  makeExtraPlayer(value, team) {
    this.extraPlayer = { team: team, uid: value }
  }

  sendExtraPlayer() {
    if(!this.overrides) this.overrides = this.match.overrides || {}
    this.overrides.extraPlayer = this.extraPlayer
    this.match.post('update-match-details', { overrides: this.overrides } )
      .then(() => {
        notify('Set new value', { level: 'success', timeout: 3000 })
        this.state.reload(true)
        emitter.emit('match-updated')
    })
  }

  fixMap() {
    if(!this.overrides) this.overrides = this.match.overrides || {}
    this.overrides.mapOverride = []

    for(const [index, map] of Object.entries(this.newMaps)) {
      if(!map.name) continue
      const newMap =
      {
            "mapNumber": map.number,
            "adjustedMapNumber": map.number,
            "mapName": map.name,
      }
      this.overrides.mapOverride.push(newMap)
    }
    this.match.post('update-match-details', { overrides: this.overrides } )
      .then(() => {
        this.match.post('compute-only')
          .then(() => {
            notify('Set new value', { level: 'success', timeout: 3000 })
            this.state.reload(true)
            emitter.emit('Fixed maps')
        })
    })
  }

  syncProjectedPoints(team) {
    this.match.post('stats', { }).then(() => {
      notify('Projected Points synced', { level: 'success', timeout: 3000 })
      this.state.reload(true)
      team.showStats = true
      emitter.emit('match-updated')
    })
  }

  teamPlayers(team) {
    const set = this.lineups
      .filter(l => ['confirmed', 'bench'].includes(l.status))
      .filter(l => l.team === team)
      .reduce((set, l) => set.add(l.player), new Set())
    return Array.from(set)
      .sort((a, b) => a.name.localeCompare(b.name))
  }

  addTeamLineup(block, team, id) {
    /* eslint-disable eqeqeq */
    const [existing] = this.lineups
      .filter(l => ['confirmed', 'bench'].includes(l.status))
      .filter(l => l.team === team)
      .filter(l => l.player._id == id)
      .filter(l => !block.batch || !l.batch || l.batch === block.batch)
    /* eslint-enable eqeqeq */
    const lineup = existing || Lineup.create({
      match: this.match,
      player: id,
      team: team,
    })
    if (!lineup.stats) lineup.stats = {}
    if (block.batch) lineup.batch = block.batch
    if (block.stat) lineup.stats[block.stat] = 1
    if (!existing) this.lineups.push(lineup)
    this.state.render()
    return lineup
  }
  isStatEnabled(stat) {
    return this.enabledStats && this.enabledStats[stat]
  }
  setRoundScore(value, mapNumber, side) {
    if(!this.overrides) this.overrides = this.match.overrides || {}
    this.overrides.roundScores = this.newRoundScores || this.match.roundScores || [[]]
    if(!this.overrides.roundScores[mapNumber]) {
      this.overrides.roundScores[mapNumber] = [0,0]
    }
    this.overrides.roundScores[mapNumber][side] = parseInt(value)
  }
  setScore(value, side) {
    if(!this.overrides) this.overrides = this.match.overrides || {}
    this.overrides.scores = this.overrides.scores || [0,0]
    this.overrides.scores[side] = parseInt(value)
    this.overrides.subScore = null
  }

  async saveScoreChanges() {
    await this.match.post('update-match-details', { overrides: this.overrides } )
    await this.match.post('compute-only')
    notify('Saved score changes', { level: 'success', timeout: 3000 })
    this.state.reload(true)
  }
  async invalidateSpecificRound() {
    const clearRound = this.clearRound
    if(!clearRound) return
    const events = this.match.events
      .filter(e => e.batch === this.clearBatch)
      .filter(e => {
        return Math.floor((e.minute % 1000) / 10) === clearRound
      })
    this.match.post('destroy-all-events', { eventsByName: events }).then(() => {
      notify('Deleted events', { level: 'success', timeout: 3000 })
      this.state.reload(true)
    })
  }

  setClearRound(round) {
    this.clearRound = parseInt(round)
  }

  setClearBatch(batch) {
    this.clearBatch = parseInt(batch)
  }
  async editMatchStats() {
    const question = `
      Overriding match stats. Are you sure?
    `
    const confirmation = await prompt(question, {
      type: 'custom',
      level: 'danger',
      submitBtnName: 'Do it',
      cancelBtnName: 'Abort',
    })
    if(!this.overrides) this.overrides = {}
    const toDelete = []
    if(this.overrides.roundScores) {
      for(const [i, rs] of this.overrides.roundScores.entries()) {
        console.log(i, rs, this.match.locations[i])
        if(!this.match.locations[i]) {
          toDelete.push(i)
        }
      }
    } else if(this.match.roundScores.length > this.match.locations.length) {
      for(const [i, rs] of this.match.roundScores.entries()) {
        console.log(i, rs, this.match.locations[i])
        if(!this.match.locations[i]) {
          toDelete.push(i)
        }
      }
    }
    const roundScores = this.match.roundScores
    for(const i of toDelete) {
      if(this.overrides.roundScores) {
        this.overrides.roundScores.pop()
      }
      roundScores.pop()
    }
    this.match.post('update-match-details', { overrides: this.overrides, roundScores } )
      .then(() => {
        this.match.post('compute-only').then(() => {
          notify('Set new value', { level: 'success', timeout: 3000 })
          this.state.reload(true)
          emitter.emit('match-updated')
        })
    })
  }
  toggleFixMenu() {
    this.fixMenu = !this.fixMenu
    this.render()
  }
  toggleSums() {
    this.showSums = !this.showSums
    this.render()
  }
  async toggleAutoconfirm(e) {
    await prompt('Are you sure you want to toggle autoconfirm?', {type: 'yesno'})
    await this.match.post('toggle-autoconfirm', { autoconfirm: this.match.autoconfirm })
    notify(`Autoconfirm turned ${!this.match.autoconfirm ? 'on' : 'off'}`, {
      level: 'success',
      timeout: 3000,
    })
    this.match.autoconfirm = !this.match.autoconfirm
    emitter.emit('match-updated')
    this.render()
  }
  async toggleCompute(on) {
    await this.match.post('toggle-compute', { compute: on })
    notify(`Computations turned ${on ? 'on' : 'off'}`, {
      level: 'success',
      timeout: 3000,
    })
    this.match.stopCompute = !on
    emitter.emit('match-updated')
    this.render()
  }

  get team() {
    return getState(this.match).team
  }

  get state() {
    return getState(this.match)
  }
  get hasEditableMatchStats() {
    return this.match.sport === 'csgo' || (editableMatchStats[this.match.sport])
  }

  get editableMatchStats() {
    return editableMatchStats[this.match.sport]
  }
  get blocks() {
    switch(this.match && this.match.sport) {
      case 'curling':
        return []
      case 'futsal':
        return [{}]
      case 'e_football':
        return [{}]
      case 'cricket':
        return [{}]
      case 'CSGO':
        return [{}]
      case 'hockey':
        return [{
          header: 'GK',
          goalkeeper: 'goalkeeper',
        }, {
          header: 'Sub',
          goalkeeper: 'goalkeeper',
          bench: 'bench',
        }, {
          header: 'Skaters',
          'not-goalkeeper': 'not-goalkeeper',
        }, {
          'not-goalkeeper': 'not-goalkeeper',
          bench: 'bench',
        }]
      default:
        return [{
        }, {
          header: 'Subs',
          bench: 'bench',
        }]
    }
  }
  get statBlocks() {
    switch(this.match && this.match.sport) {
      case 'american_football':
        return [{
          header: 'Offensive',
          'exclude-position': 'defense_special',
          isEditable: this.editMode,
        }, {
          header: 'Defensive',
          position: 'defense_special',
          isEditable: this.editMode,
        }]
      case 'baseball':
        return [{
          header: 'Defensive',
          position: 'pitcher',
          isEditable: this.editMode,
        }, {
          header: 'Offensive',
          'exclude-position': 'pitcher',
          isEditable: this.editMode,
        }]
      case 'lol':
      case 'dota2':
      case 'csgo':
        return this.periods
          .map(p => ({
            header: `Map ${p}, ${this.match.locations[p-1]?.map?.name}`,
            batch: p,
            addNew: true,
            isEditable: this.editMode,
          }))
      case 'cricket': {
        const periods = [...this.periods]
        if(this.lineups?.find(l => !l.batch)) {
          periods.unshift(0)
        }
        const blocks = periods.flatMap(p => [{
          header: `Batsmen (${p})`,
          batch: p,
          stat: p ? 'ball' : null,
          context: 'ball',
          addNew: true,
          isEditable: this.editMode,
        }, {
          header: `Bowlers (${p})`,
          batch: p,
          stat: p ? 'over' : null,
          addNew: true,
          isEditable: this.editMode,
        }, {
          header: `Fielders (${p})`,
          batch: p,
          isEditable: this.editMode,
          stats: p ? JSON.stringify([
            'caught',
            'stumping',
            'runOut',
            'runOutThrown',
            'runOutCaught',
          ]) : null,
        }])

        return blocks
      }

      default: {
        const ret = [{
          'exclude-position': 'goalkeeper',
          isEditable: !!this.editMode,
        }]
        if(this.match.hasGoalkeeper) {
          ret.unshift({
            position: 'goalkeeper',
            isEditable: !!this.editMode,
          })
        }
        return ret
      }
    }
  }

  allStats(batch, team) {
    const lineup = this.lineups.find(l => l.batch === batch && team._id === l.team.toString())
    if(!lineup) return
    return Object.keys(lineup.stats)
  }

  findTotalStat(stat, batch, team) {
    const lineups = this.lineups.filter(l => l.batch === batch && team._id === l.team.toString())
    const statSum = lineups.reduce((a, b) => a + b.stats[stat], 0)
    return statSum
  }

  canClearEvents(source) {
    return [
      'sportmonksFootball',
      'sportmonksFootball3',
    ].includes(source.source)
  }

  get periods() {
    const ret = (this.lineups || [])
      .filter(l => l.batch)
      .reduce((set, l) => set.add(l.batch), new Set())
    if(!ret.size) return [1]
    return Array.from(ret)
      .sort((a, b) => a - b)
  }

  get sport() {
    return this.match && this.match.sport
  }

  get isEsports() {
    return [
      'csgo',
      'dota2',
      'lol',
    ].includes(this.sport)
  }

  get canStopCompute() {
    return [
      'csgo',
      'handball',
      'dota2',
    ].includes(this.sport)
  }

  get isQuickSets() {
    return this.state.isQuickSets
  }
}
